import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const it = {
  app_name: "TCF Platform",
  login: "Accedi", logout: "Esci", register: "Registrati",
  email: "Email", password: "Password", remember_me: "Ricordami",
  forgot_password: "Password dimenticata?",
  dashboard: "Dashboard", risk_map: "Mappa Rischi", controls: "Controlli",
  documents: "Documenti", calendar: "Calendario", reports: "Report",
  ade_communications: "Comunicazioni ADE", certification: "Certificazione",
  settings: "Impostazioni", admin: "Super Admin", pmi_guide: "Guida PMI",
  ai_settings: "Configurazione AI",
  welcome_back: "Bentornato",
  enter_credentials: "Inserisci le credenziali per accedere alla piattaforma TCF",
  no_account: "Non hai un account?",
  create_account: "Crea account",
};

const en = {
  app_name: "TCF Platform",
  login: "Sign in", logout: "Sign out", register: "Register",
  email: "Email", password: "Password", remember_me: "Remember me",
  forgot_password: "Forgot password?",
  dashboard: "Dashboard", risk_map: "Risk Map", controls: "Controls",
  documents: "Documents", calendar: "Calendar", reports: "Reports",
  ade_communications: "ADE Communications", certification: "Certification",
  settings: "Settings", admin: "Super Admin", pmi_guide: "SME Guide",
  ai_settings: "AI Settings",
  welcome_back: "Welcome back",
  enter_credentials: "Enter your credentials to access TCF Platform",
  no_account: "Don't have an account?",
  create_account: "Create account",
};

i18n.use(initReactI18next).init({
  resources: { it: { translation: it }, en: { translation: en } },
  lng: localStorage.getItem("tcf_lang") || "it",
  fallbackLng: "it",
  interpolation: { escapeValue: false },
});

export default i18n;
